import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { CurrencyFormatterPipe } from './pipe/currency-formatter-pipe.pipe';
import { TableSearchFilterPipePipe } from './pipe/table-search-filter-pipe.pipe';
import { TimeOnlyPipePipe } from './pipe/time-only-pipe.pipe';

@NgModule({
  declarations: [CurrencyFormatterDirective, CurrencyFormatterPipe, TableSearchFilterPipePipe, TimeOnlyPipePipe],  // Declare the directive here
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CurrencyFormatterDirective, CurrencyFormatterPipe, TableSearchFilterPipePipe, TimeOnlyPipePipe]
})
export class SharedModule { }
